import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";
import { FaPlus } from "react-icons/fa";
import { FiRefreshCcw } from "react-icons/fi";
import SavPagination from "../../../components/SavPagination";
import SavColumnSort from "../../../components/SavColumnSort";
import SavSearchB from "../../../components/SavSearch";
import SavDrop from "../../../components/SavDrop";
import {
  SavRow,
  SavSearch,
  // HeaderBlock,
  HeaderBlockContent,
  HeaderBlockTitle,
  StatusPill
} from "../../../components/Styled";
import {createNotification, fetchNotifications} from "../../../actions";
import styled from "styled-components";

const HeaderBlock = styled.div`
  min-height: 190px;
  padding: 50px 15px;
  background-color: #fafaf9;
  text-transform: uppercase;
  font-size: 18px;
  text-align: center;
  font-family: "Gotham-Book";
`;

const Education = props => {
  const { education, user, createNotification, notifications, fetchNotifications, success } = props;

  const [educationList, setEducationList] = useState([]);
  const [educationFilter, setEducationFilter] = useState([]);

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchString, setSearchString] = useState("");
  const [activeFilter, setActiveFilter] = useState("All");
  const [isNDD, setIsNDD] = useState(false);
  
  const SFTOKEN = localStorage.getItem("sfsid");

  const [colOne, setColOne] = useState(null);
  const [colTwo, setColTwo] = useState(null);
  const [colThree, setColThree] = useState(null);
  const [colFour, setColFour] = useState(null);

  const [colOneTotal, setColOneTotal] = useState(0);
  const [colTwoTotal, setColTwoTotal] = useState(0);
  const [colThreeTotal, setColThreeTotal] = useState(0);
  const [colFourTotal, setColFourTotal] = useState(0);

  const [dataCols, setDataCols] = useState([]);

  useEffect(() => {
    if (!_.isEmpty(user)){
      if(user.contact.accType === 'Non-Direct' && user.contact.accSubType === 'US Distribution'){
        setIsNDD(true);
      }
    }
  }, [user]);

  useEffect(() => {
    if (!_.isEmpty(education)) {    
      let countOne = 0;
      let countTwo = 0;
      let countThree = 0;
      let countFour = 0;
      education.trainings.forEach(e => {
        if (e.statusCol1 === 'COMPLETE') {
          countOne += 1;
        }
        if (e.statusCol2 === 'COMPLETE') {
          countTwo += 1;
        }
        if (e.statusCol3 === 'COMPLETE'){
          countThree +=1;
        }
        if (e.statusCol4 === 'COMPLETE'){
          countFour +=1;
        }
      });
      setColOneTotal(countOne);
      setColTwoTotal(countTwo);
      setColThreeTotal(countThree);
      setColFourTotal(countFour);
      setEducationList(education.trainings);

      if (education.columns[0]){
        setColOne(education.columns[0]);
      }
      if (education.columns[1]){
        setColTwo(education.columns[1]);
      }
      if (education.columns[2]){
        setColThree(education.columns[2]);
      }
      if (education.columns[3]){
        setColFour(education.columns[3]);
      }

      let tempCols;


      if (education.columns.length === 1){
        tempCols = [
          { text: "Name", size: 6, sizeXS: 6, value: "contactName" },
          { text: education.columns[0].label, size: 6, sizeXS: 6, value: "statusCol1" },
        ];
      }
      if (education.columns.length === 2){
        tempCols = [
          { text: education.columns[0].label, size: 4,sizeXS: 3, value: "contactName" },
          { text: education.columns[1].label, size: 4, sizeXS: 2, value: "statusCol1" },
          { text: education.columns[2].label, size: 4, sizeXS:2, value: "statusCol2" },
        ];
      }
      if (education.columns.length === 3){
        tempCols = [
          { text: "Name", size: 3,sizeXS: 3, value: "contactName" },
          { text: education.columns[0].label, size: 3, sizeXS:3, value: "statusCol1" },
          { text: education.columns[1].label, size: 3, sizeXS:3, value: "statusCol2" },
          { text: education.columns[2].label, size: 3, sizeXS:3, value: "statusCol3" },
        ];
      }
      if (education.columns.length === 4){
        tempCols = [
          { text: "Name", size: 4,sizeXS: 4, value: "contactName" },
          { text: education.columns[0].label, size: 2, sizeXS: 2, value: "statusCol1" },
          { text: education.columns[1].label, size: 2, sizeXS:2, value: "statusCol2" },
          { text: education.columns[2].label, size: 2, sizeXS:2, value: "statusCol3" },
          { text: education.columns[3].label, size: 2, sizeXS: 2, value: "statusCol4" },
        ];
      }
      setDataCols(tempCols);
    }
  }, [education]);

  useEffect(() => {
    if (!_.isEmpty(education)){
      if (activeFilter !== "All"){
        setCurrentPage(1);

        const match = activeFilter.match(/untrained\s+(\w+)/i);

        if (match){
          let filterColIndex = education.columns.findIndex(i => i.label === match[1]);

          if (filterColIndex === 0){
            let temp = education.trainings.filter(
              e => e.statusCol1 === 'TO-DO' || e.statusCol1 === 'WIP'
            );
            setEducationList(temp);
          }
          if (filterColIndex === 1){
            let temp = education.trainings.filter(
              e => e.statusCol2 === 'TO-DO' || e.statusCol2 === 'WIP'
            );
            setEducationList(temp);
          }
          if (filterColIndex === 2){
            let temp = education.trainings.filter(
              e => e.statusCol3 === 'TO-DO' || e.statusCol3 === 'WIP'
            );
            setEducationList(temp);
          }
          if (filterColIndex === 3){
            let temp = education.trainings.filter(
              e => e.statusCol4 === 'TO-DO' || e.statusCol4 === 'WIP'
            );
            setEducationList(temp);
          }
        }
      }else {
        setEducationList(education.trainings);
      }
    }
  },[activeFilter]);

  useEffect(() => {
    if (educationList) {
      let index = 0;
      const temp = [];
      for (index = 0; index < educationList.length; index += pageSize) {
        let chunk = educationList.slice(index, index + pageSize);
        temp.push(chunk);
      }
      setEducationFilter(temp);
    }
  }, [educationList, pageSize]);

  useEffect(() => {
    if(searchString !== ""){
      let temp = education.trainings.filter(contact => 
        SavSearchB(contact, ["contactName"], searchString)
      );
      setEducationList(temp);
    } else {
      if (!_.isEmpty(education)){
        setEducationList(education.trainings)
      }
      
    }
  }, [searchString])

  const handleNotification = (contact, index) => {

    const course = education.columns[index];

    let notificationJSON = [
      {
        isRead: false,
        contactId: contact.contactId,
        message:user.contact.firstName + ' ' + user.contact.lastName + ' would like you to enroll in '+ course.label,
        course: course.label,
        target: course.enrollmentUri,
        isExternal: true,
      }
    ];
    
    createNotification(notificationJSON).then(() => {
      fetchNotifications();
    })
  }

  const renderButton = (e, status, index) => {
    if (status === "TO-DO"){
      return <StatusPill style={{cursor:'pointer'}} onClick={() => handleNotification(e, index)}>Enroll&nbsp;&nbsp;<FaPlus /></StatusPill>
    }
    if (status === 'WIP'){
      return <StatusPill bg="#ffcc5f" color="#fff" border="1px solid #ffcc5f">WIP&nbsp;&nbsp;<FiRefreshCcw style={{stroke:'#fff'}} /></StatusPill>
    }
    if (status === 'COMPLETE'){
      return <StatusPill bg="#4cd964" color="#fff" border="1px solid #4cd964">Complete</StatusPill>
    }
  }

  const renderList = () => {
    if (!_.isEmpty(educationFilter)) {
      let page = currentPage - 1;
      if (page < 1) {
        page = 0;
      }
      if (page > educationFilter.length) {
        page = 0;
        setCurrentPage(1);
      }

      const renderRow = (e) => {
        if (education.columns.length === 1){
          return (
            <SavRow key={e.contactId}>
              <Col xs={6}><Link to={`/education/${e.contactId}`} className="u truncate">{e.contactName}</Link></Col>
              <Col xs={6}>{renderButton(e, e.statusCol1, 0)}</Col>
            </SavRow>
          )
        }
        if (education.columns.length === 2){
          return (
            <SavRow key={e.contactId}>
              <Col xs={4}><Link to={`/education/${e.contactId}`} className="u truncate">{e.contactName}</Link></Col>
              <Col xs={4}>{renderButton(e, e.statusCol1, 0)}</Col>
              <Col xs={4}>{renderButton(e, e.statusCol2, 1)}</Col>
            </SavRow>
          )
        }
        if (education.columns.length === 3){
          return (
            <SavRow key={e.contactId}>
              <Col xs={3}><Link to={`/education/${e.contactId}`} className="u truncate">{e.contactName}</Link></Col>
              <Col xs={3}>{renderButton(e, e.statusCol1, 0)}</Col>
              <Col xs={3}>{renderButton(e, e.statusCol2, 1)}</Col>
              <Col xs={3}>{renderButton(e, e.statusCol3, 2)}</Col>
            </SavRow>
          )
        }
        if (education.columns.length === 4){
          return (
            <SavRow key={e.contactId}>
              <Col xs={4}><Link to={`/education/${e.contactId}`} className="u truncate">{e.contactName}</Link></Col>
              <Col xs={2}>{renderButton(e, e.statusCol1, 0)}</Col>
              <Col xs={2}>{renderButton(e, e.statusCol2, 1)}</Col>
              <Col xs={2}>{renderButton(e, e.statusCol3, 2)}</Col>
              <Col xs={2}>{renderButton(e, e.statusCol4, 3)}</Col>
            </SavRow>
          )
        }

      }
      return educationFilter[page].map(e => {
        return renderRow(e);
      });
    }
    return null;
  };

  const renderHeaders = () => {
    if (education.columns.length === 1){
      return (
        <Row style={{ marginTop: 40, marginBottom: 40 }}>
          <Col md={12}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colOne ? colOne.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colOneTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
        </Row>
      )
    }
    if (education.columns.length === 2){
      return (
        <Row style={{ marginTop: 40, marginBottom: 40 }}>
          <Col md={6}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colOne ? colOne.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colOneTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
          <Col md={6}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colTwo ? colTwo.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colTwoTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
        </Row>
      )
    }
    if (education.columns.length === 3){
      return (
        <Row style={{ marginTop: 40, marginBottom: 40 }}>
          <Col md={4}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colOne ? colOne.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colOneTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
          <Col md={4}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colTwo ? colTwo.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colTwoTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
          <Col md={4}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colThree ? colThree.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colThreeTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>

        </Row>
      )
    }
    if (education.columns.length === 4){
      return (
        <Row style={{ marginTop: 40, marginBottom: 40 }}>
          <Col md={3}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colOne ? colOne.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colOneTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
          <Col md={3}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colTwo ? colTwo.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colTwoTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
          <Col md={isNDD ? 4 : 3}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colThree ? colThree.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colThreeTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
          <Col md={isNDD ? 4 : 3} style={colFour ? null : {display:'none'}}>
            <HeaderBlock>
              <HeaderBlockTitle className="f14">Total Trained {colFour ? colFour.label : null}</HeaderBlockTitle>
              <HeaderBlockContent className="oj f24">{colFourTotal}</HeaderBlockContent>
            </HeaderBlock>
          </Col>
        </Row>
      )
    }
  }

  if (educationList && user && !_.isEmpty(education)) {
    let filterOpts = ['All'];
    education.columns.forEach((c) => {
      filterOpts.push(`Untrained ${c.label}`);
    })

    return (
      <div>
        <Container>
          {renderHeaders()}
          <Row className="vertical-align">
            <Col md={8} className="d-none d-md-block">
              <SavSearch
                type="search"
                placeholder="Search.."
                width="80%"
                value={searchString}
                onChange={e => setSearchString(e.target.value)}
              />
            </Col>
            <Col sm={12} md={4} className="d-flex justify-content-lg-end justify-content-center mt-3 mt-md-0 ">
              <div className="d-flex align-items-center" style={{width:300}}>
                <div className="light-gray f12 med" style={{marginRight:5}}>FILTER</div>
                <SavDrop
                  opts={filterOpts}
                  val={activeFilter}
                  click={setActiveFilter}
                  style={{
                    border: "1px solid #b4b4b4",
                    backgroundColor: "#fff",
                    width:250
                  }}
                />
              </div>
            </Col>
          </Row>

          <hr />
          <SavColumnSort
            data={educationList}
            setData={setEducationList}
            columns={dataCols}
          />
          {renderList()}
          <SavPagination
            data={educationFilter}
            pageSize={pageSize}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            dataLength={educationList.length}
          />
        </Container>
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => {
  return {
    education: state.education.data,
    notifications: state.notifications.items,
    user: state.user.data
  };
};

export default connect(mapStateToProps, { createNotification,fetchNotifications })(Education);